import { Routes } from '@angular/router';

export const dnsRecordsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./dns-records.component').then((m) => m.DnsRecordsComponent),
  },
];
